import { FileDispositionEnum } from '@graphql/generated';
import { FileDisposition } from '@lib/ged/file-disposition.type';

export class FileDispositionMapper {
  public static fromGraphQl = (
    disposition?: FileDispositionEnum | string | null
  ): FileDisposition | undefined => {
    const mapping: Record<FileDispositionEnum, FileDisposition> = {
      RECTO_VERSO: 'recto-verso',
      RECTO: 'recto',
      VERSO: 'verso',
    };
    return disposition ? mapping[disposition as FileDispositionEnum] : undefined;
  };

  public static toGraphQl = (
    fileDisposition?: FileDisposition
  ): FileDispositionEnum | undefined => {
    const mapping: Record<FileDisposition, FileDispositionEnum> = {
      'recto-verso': FileDispositionEnum.RectoVerso,
      recto: FileDispositionEnum.Recto,
      verso: FileDispositionEnum.Verso,
    };

    return fileDisposition ? mapping[fileDisposition] : undefined;
  };
}
